import styled from "@emotion/styled";
export const StyledIframeComponent = styled.div`
  width: 100%;
  display: flex;
  .iframe-core-component {
    width: 100%;
  }
`;
